import React from 'react'
import 'react-table/react-table.css'
import TileGroup from './TileGroup'

export default class Table extends React.Component {

  updateTable(table) {

    let data = this.props.data
    if (data) {
      Object.keys(data).forEach(child => {
        let mods = data[child]
        let person = child

        Object.keys(mods).forEach(entry => {
          let day, start, end, module_code, type, venue, week, hidden, custom, key;
          start = parseInt(mods[entry].start)
          end = parseInt(mods[entry].end)
          module_code = mods[entry].module_code
          type = mods[entry].type.slice(0, 3).toUpperCase()
          venue = mods[entry].venue
          week = mods[entry].week
          hidden = mods[entry].hidden
          custom = mods[entry].custom
          key = entry

          switch (mods[entry].day) {
            case "Monday": day = 0;
              break;
            case "Tuesday": day = 1;
              break;
            case "Wednesday": day = 2;
              break;
            case "Thursday": day = 3;
              break;
            case "Friday": day = 4;
              break;
            default: day = -1;
              break;
          }

          let rowArr = []  
        
          for(let i = start; i < end; i+=100) {
            let rowFilled = []
            let assigned = false
            table[day][i].map((key, index) => {
              rowFilled.push(key.row)
            })
            rowFilled.sort()

            for(let k = 0; k < rowFilled.length; k++) {
              if(rowFilled[k] != k && !assigned) {
                rowArr.push(k)
                assigned = true
              }
            }
            if(!assigned) {
              rowArr.push(rowFilled.length)
            }
          }

          let row = Math.max.apply(null, rowArr)


          for (let i = start; i < end; i += 100) {
            // find the right row first
            // then add to the row

            table[day][i].push({
                  module_code: module_code,
                  day: day,
                  start: start,
                  end: end,
                  type: type,
                  venue: venue,
                  person: person, 
                  row: row,
                  week: week,
                  hidden: hidden,
                  custom: custom,
                  key: key
                })
          }
        })
      })
    }
    console.log(table)
  }



  render() {

    let data = [
      {
        800: [],
        900: [],
        1000: [],
        1100: [],
        1200: [],
        1300: [],
        1400: [],
        1500: [],
        1600: [],
        1700: [],
        1800: [],
        1900: [],
        2000: [],
        2100: []
      }, {
        800: [],
        900: [],
        1000: [],
        1100: [],
        1200: [],
        1300: [],
        1400: [],
        1500: [],
        1600: [],
        1700: [],
        1800: [],
        1900: [],
        2000: [],
        2100: []
      }, {
        800: [],
        900: [],
        1000: [],
        1100: [],
        1200: [],
        1300: [],
        1400: [],
        1500: [],
        1600: [],
        1700: [],
        1800: [],
        1900: [],
        2000: [],
        2100: []
      }, {
        800: [],
        900: [],
        1000: [],
        1100: [],
        1200: [],
        1300: [],
        1400: [],
        1500: [],
        1600: [],
        1700: [],
        1800: [],
        1900: [],
        2000: [],
        2100: []
      }, {
        800: [],
        900: [],
        1000: [],
        1100: [],
        1200: [],
        1300: [],
        1400: [],
        1500: [],
        1600: [],
        1700: [],
        1800: [],
        1900: [],
        2000: [],
        2100: []
      }
    ]

    this.updateTable(data)
    return (
      <div className="Table p-3">
        <div className="table-responsive">
          <table className="table table-striped small table-small">
            <thead>
              <tr className="text-left">
                <th scope="col"></th>
                {["0800", "0900", "1000", "1100", "1200", "1300", "1400", "1500", "1600", "1700", "1800", "1900", "2000", "2100"]
                  .map((key, index) => (
                    <th scope="col" key={index} style={{ paddingLeft: "1px", paddingBottom: "1px" }}>{key}</th>
                  ))
                }
              </tr>
            </thead>


            {["MON", "TUE", "WED", "THU", "FRI"].map((key, index) => {
              let rows = 1
              Object.keys(data[index]).map((key2, index2) => {
                if(data[index][key2].length > rows) {
                  rows = data[index][key2].length
                }
              })
              return (
                <tbody key={index}>
                  <tr>
                    <th rowSpan={rows}>{key}</th>
                    {Object.keys(data[index]).map((key2, index2) => (
                      <TileGroup key={index2} info={data[index][key2]} users={this.props.users} row="0" time={key2} room={this.props.room}/>
                    ))}
                  </tr>
                  {[...Array(rows-1)].map((e, i) => (
                    <tr key={i}>
                    {Object.keys(data[index]).map((key2, index2) => (
                      <TileGroup key={index2} info={data[index][key2]} users={this.props.users} row={i+1} time={key2} room={this.props.room}/>
                    ))}
                  </tr>
                  ))}
                  <tr>
                    <td colSpan="15" className="bg-light" />
                  </tr>
                </tbody>
              )
            }
            
            )}
          </table>
        </div>

      </div>
    )
  }
}